export default __webpack_public_path__ + "iltalehti_logo.svg";